import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center p-8" data-testid="notfound-page">
      <div className="text-center">
        <div className="font-display text-8xl text-[#ff1493]">404</div>
        <div className="font-display text-2xl mt-3">Compound not found.</div>
        <Link to="/" className="mt-6 inline-block px-5 py-3 bg-black text-white border-[3px] border-black shadow-brut btn-press font-mono-ui text-xs font-bold">
          BACK TO HOME
        </Link>
      </div>
    </div>
  );
}
